import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import HomePage from '@/views/HomePage.vue'

const routes: Array<RouteRecordRaw> = [

  // Home page
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: HomePage
  },



]
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})
console.log(router.getRoutes())
export default router
